import type { PendingToolApproval } from '@heidi/agents/contracts';

import { isRunComputerUseTaskApproval } from './desktop-control-lease';

export interface ComputerUseApprovalCandidate {
  toolName?: string | null;
  approvalKind?: string | null;
}

export const isComputerUseApprovalCandidate = ({
  toolName,
  approvalKind,
}: ComputerUseApprovalCandidate): boolean => {
  if (isRunComputerUseTaskApproval(toolName ?? undefined)) return true;
  if (approvalKind === 'computer_use') return true;
  if (toolName?.trim().toLowerCase() === 'computer use') return true;
  return false;
};

export const isComputerUsePendingApproval = (approval: PendingToolApproval): boolean =>
  isComputerUseApprovalCandidate({
    toolName: approval.toolName,
    approvalKind: approval.approvalKind,
  });
